import { render, staticRenderFns } from "./CollapsableTitle.vue?vue&type=template&id=60e66330&scoped=true"
import script from "./CollapsableTitle.vue?vue&type=script&lang=js"
export * from "./CollapsableTitle.vue?vue&type=script&lang=js"
import style0 from "./CollapsableTitle.vue?vue&type=style&index=0&id=60e66330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e66330",
  null
  
)

export default component.exports